<template>
  <div class="columns">
    <div class="column" style="padding-right: 0rem">
      <article class="notification cnotification">
        <div class="media">
          <div class="media-content">
            <span class="clabel"
              >{{ dropFiles.length }}
              {{ $t('compTransitionUpload.attach-files') }}</span
            >
            <a
              v-if="dropFiles.length > 0"
              @click="displayFiles = !displayFiles"
              class="link"
            >
              {{
                !displayFiles
                  ? $t('compTransitionUpload.show')
                  : $t('compTransitionUpload.hide')
              }}
              <b-icon :icon="!displayFiles ? 'caret-down' : 'caret-up'" />
            </a>
          </div>
        </div>
      </article>
      <b-collapse animation="slide" v-model="displayFiles">
        <b-taglist>
          <b-tag
            v-for="(file, index) in dropFiles"
            style="cursor: pointer"
            :key="index"
            icon="file"
            type="is-small"
            class="ctag"
            closable
            @close="deleteAttachedFile(file, index)"
            @click="clickFile(file)"
          >
            <strong> {{ file.name | truncate(15) }} </strong>
            <span style="color: #979797">{{
              file.size | convertFileSize
            }}</span>
          </b-tag>
        </b-taglist>
      </b-collapse>
    </div>
    <div class="column is-1 is-flex is-vcentered" style="padding-left: 0rem">
      <b-upload
        v-model="dropFiles"
        expanded
        multiple
        :accept="accept"
        @input="(event) => $emit('input', event)"
      >
        <a class="button is-fullwidth" style="background-color: #f5f5f5">
          <b-icon icon="paperclip" />
        </a>
      </b-upload>
    </div>
    <div class="column is-3 is-vcentered" v-if="withQuota">
      <quota-status
        :actionSize="currentActionQuota"
        :actionQuota="actionQuota"
        :globalSize="quota"
        :globalQuota="maxQuota"
        :additionalSize="additionalQuota"
      />
    </div>
  </div>
</template>

<script>
import { useCoreStore } from '@/stores/core.js'
import transitionService from '@/services/transitionService.js'
import { Background } from '@/mixins/background.js'

import { openFileAsync } from '../../models/transition/utils'

import _ from 'lodash'

export default {
  name: 'Upload',
  props: {
    dropFiles: {
      type: Array
    },
    quota: {
      type: Number
    },
    maxQuota: {
      type: Number
    },
    actionQuota: {
      type: Number
    },
    withQuota: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: { 'quota-status': () => import('./QuotaStatus.vue') },
  $_veeValidate: {
    validator: 'new'
  },
  mixins: [Background],
  emit: ['update:dropFiles', 'onDeleteActionFile', 'input', 'remainingQuota'],
  data: function () {
    return {
      // Display the files to attach
      displayFiles: false
    }
  },
  watch: {
    dropFiles (newDropFiles, oldDropFiles) {
      // update v-model
      this.$emit('update:dropFiles', newDropFiles)
    }
  },
  computed: {
    additionalQuota () {
      let initialSize = this.currentActionQuota
      let totalSize = _.sumBy(this.dropFiles, (f) => f.size)
      let size = totalSize - initialSize
      return size
    },
    currentActionQuota () {
      // this are the saved File
      let savedFiles = this.dropFiles.filter((f) => !(f instanceof File))
      return _.sumBy(savedFiles, (f) => f.size)
    },
    /**
     * Get the accepted mime type from the conf
     */
    accept () {
      return this.coreStore.setting('transition', 'ACCEPTED_MIME_TYPES').value
    },
    disableUpload () {
      return this.maxQuota === 0
    }
  },
  methods: {
    computeBarType () {
      if (this.quota + this.additionalQuota < 50) {
        return 'is-success'
      } else if (this.quota + this.additionalQuota < 75) {
        return 'is-warning'
      }
      return 'is-danger'
    },

    deleteAttachedFile (file, index) {
      // we need to distinguish two types of files:
      // 1. remote files (already uploaded)
      // 2. local files (not uploaded yet)
      //
      // 1. & 2. we remove from the dropFiles list
      // but for 1. we also emit the event (which will actually
      // remove the file by making a remote call)
      if (file.id) {
        // TODO(msimonin) we could defer this when the user click on "save"
        // otherwise the delete action is taken into account asap which
        // can be counter intuitive
        this.$buefy.dialog.confirm({
          title: this.$t('compTransitionUpload.title-delete-file'),
          message: this.$t('compTransitionUpload.message-delete-file'),
          trapFocus: true,
          onConfirm: (value) => {
            this.$emit('onDeleteActionFile', file)
          }
        })
      } else {
        this.dropFiles.splice(index, 1)
      }
    },
    clickFile (file) {
      if (file.url) {
        openFileAsync(transitionService.getFile(file), file.name)
      }
    }
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  mounted () {}
}
</script>

<style>
.ql-toolbar,
.ql-container {
  background-color: #fff;
}

.clabel {
  color: #363636;
  font-size: 1rem;
  font-weight: 700;
  padding-right: 10px;
}

.tags .ctag {
  height: 3em;
}

.cnotification {
  padding: 0.5rem 2.5rem 0.5rem 1.5rem;
}
</style>
